module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/full-c0f11eeae0f588cb54be92253613e84a.svg";